var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCoinStack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "coin-stack"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M7.28065 11.6043C7.91233 11.6043 8.52291 11.5635 9.10069 11.4875V5.15454C8.52297 5.07864 7.91233 5.03784 7.28065 5.03784C3.67388 5.03784 0.75 6.36394 0.75 7.99984V8.64221C0.75 10.278 3.67388 11.6043 7.28065 11.6043Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M7.28065 14.911C7.91233 14.911 8.52291 14.8702 9.10069 14.7943V12.938C8.5228 13.0139 7.9125 13.0553 7.28065 13.0553C4.13233 13.0553 1.50459 12.0448 0.887351 10.7C0.797463 10.8958 0.75 11.0987 0.75 11.3066V11.949C0.75 13.5849 3.67388 14.911 7.28065 14.911Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M9.10069 16.3894V16.2452C8.5228 16.3211 7.9125 16.3624 7.28065 16.3624C4.13233 16.3624 1.50459 15.3519 0.887351 14.0071C0.797463 14.2029 0.75 14.4058 0.75 14.6137V15.2561C0.75 16.892 3.67388 18.2181 7.28065 18.2181C8.00194 18.2181 8.69569 18.1649 9.34444 18.067C9.18364 17.738 9.10069 17.3911 9.10069 17.0318V16.3894Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M16.6967 0.0212402C13.0899 0.0212402 10.166 1.34734 10.166 2.98324V3.62561C10.166 5.2615 13.0899 6.5876 16.6967 6.5876C20.3034 6.5876 23.2273 5.2615 23.2273 3.62561V2.98324C23.2273 1.34734 20.3034 0.0212402 16.6967 0.0212402Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M16.6967 8.03869C13.5483 8.03869 10.9206 7.02826 10.3034 5.68335C10.2135 5.87919 10.166 6.08203 10.166 6.29001V6.93238C10.166 8.56828 13.0899 9.89438 16.6967 9.89438C20.3034 9.89438 23.2273 8.56828 23.2273 6.93238V6.29001C23.2273 6.08203 23.1799 5.87919 23.09 5.68335C22.4727 7.02826 19.845 8.03869 16.6967 8.03869Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M16.6967 11.3458C13.5483 11.3458 10.9206 10.3353 10.3034 8.99048C10.2135 9.18632 10.166 9.38915 10.166 9.59714V10.2395C10.166 11.8755 13.0899 13.2016 16.6967 13.2016C20.3034 13.2016 23.2273 11.8755 23.2273 10.2395V9.59714C23.2273 9.38915 23.1799 9.18632 23.09 8.99048C22.4727 10.3354 19.845 11.3458 16.6967 11.3458Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M16.6967 14.8312C13.5483 14.8312 10.9206 13.8207 10.3034 12.4758C10.2135 12.6717 10.166 12.8745 10.166 13.0824V13.7249C10.166 15.3608 13.0899 16.6869 16.6967 16.6869C20.3034 16.6869 23.2273 15.3608 23.2273 13.7249V13.0824C23.2273 12.8745 23.1799 12.6716 23.09 12.4758C22.4727 13.8206 19.845 14.8312 16.6967 14.8312Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    d: "M16.6967 18.1381C13.5483 18.1381 10.9206 17.1276 10.3034 15.7828C10.2135 15.9787 10.166 16.1816 10.166 16.3894V17.0317C10.166 18.6676 13.0899 19.9937 16.6967 19.9937C20.3034 19.9937 23.2273 18.6676 23.2273 17.0317V16.3893C23.2273 16.1814 23.1799 15.9785 23.09 15.7827C22.4727 17.1276 19.845 18.1381 16.6967 18.1381Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCoinStack);
export default __webpack_public_path__ + "static/media/icon-coin-stack.ced63f4d899a675f61faa29476aed4ce.svg";
export { ForwardRef as ReactComponent };